import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect } from "react-redux";
import {DateRangeInputError } from "modules/user_management/dcdd_user/users/state/actionType";
import { ApiError } from "components";
import DateRangeForm from "./components/DataRangeForm";
import StaticsData from "./StaticsData";
import { fetchDcddTotalUserByFilter, ResetDcddFilterData } from "../state/action";
import { DcddTotalUserDataInput } from "../state/actionType";
import { fetchDzongkhag, fetchEccd, fetchSchools } from "modules/user_management/dcdd_user/users/state/action";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const FilterDCDDData: React.FC<Props> = ({ onFetchDcddUserByFilter,fetchDcddUsersByFilter, onResetData, onFetchDzongkhag,
  onFetchEccd,
  onFetchSchools, }) => {
  const [formData, setFormData] = useState<DcddTotalUserDataInput>({
    from_date: null,
    to_date: null,
    dzongkhag_id: null,
    category: null,
    school_id: null,
    eccd_id: null,
  });
  const [error, setError] = useState<DateRangeInputError>({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(null);

  useEffect(() => {
    onResetData();
    setFormData({ from_date: "", to_date: "" , dzongkhag_id: "", category: "", school_id: "", eccd_id: "" });
  }, []);
  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
  const { name, value } = e.target;

  setFormData(prev => {
    const newFormData = { ...prev, [name]: value || null };

    let newErrors: DateRangeInputError = { ...error };

  if (newFormData.from_date !== null && newFormData.to_date !== null) {
  if (newFormData.from_date > newFormData.to_date) {
    newErrors.fromDate = "From date should be earlier than To date";
    newErrors.toDate = "To date should be later than From date";
  } else {
    newErrors.fromDate = "";
    newErrors.toDate = "";
  }
}


    setError(newErrors);
    return newFormData;
  });
};

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();

    const errors: DateRangeInputError = {};

    if (!formData.from_date) {
      errors.fromDate = "From date is required";
    }
    if (!formData.to_date) {
      errors.toDate = "To date is required";
    }

    if (
      formData.from_date &&
      formData.to_date &&
      formData.from_date > formData.to_date
    ) {
      errors.fromDate = "From date should be earlier than To date";
      errors.toDate = "To date should be later than From date";
    }

    setError(errors);

    if (Object.keys(errors).length === 0) {
    }
    setSubmitted(true);
    setLoading(true);
    try {
         await onFetchDcddUserByFilter(formData);
    } catch (err) {
      console.error("Failed to fetch user:", err);
    } finally {
      setLoading(false); 
    }
  };
const filterData = fetchDcddUsersByFilter
  useEffect(() => {
    if (!fetchDcddUsersByFilter&& submitted) {
      if (fetchDcddUsersByFilter) {
        setApiError(fetchDcddUsersByFilter.error);
      } else {
        setApiError(null);
      }
    }
  }, [fetchDcddUsersByFilter, fetchDcddUsersByFilter, submitted]);
  return (
    <>
      <div className="mx-8 mt-8">
        <h2 className="text-2xl font-medium mb-2">
          Search the DCDD users by date range
        </h2>
        <DateRangeForm
          formData={formData}
          error={error}
          loading={loading}
          handleChange={handleChange}
          handleSubmit={handleSave}
          onFetchDzongkhag={onFetchDzongkhag}
          onFetchSchools={onFetchSchools}
          onFetchEccd={onFetchEccd} 
          fetchDcddState={undefined}          />
      </div>
      {apiError && <ApiError>{apiError}</ApiError>}
      <StaticsData filterDcddUserData = {filterData}/>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    fetchDcddUsersByFilter:  state.dcddTotalDataReducer.dcddTotalUserByFilterState.dcddTotalUserByFilter,
    fetchDcddState: state.dcddUser.dcddUserState,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  onFetchDcddUserByFilter: (input: DcddTotalUserDataInput) =>
    dispatch(fetchDcddTotalUserByFilter(input)),
   onResetData: () => dispatch(ResetDcddFilterData()),
   onFetchDzongkhag: () => dispatch(fetchDzongkhag()),
   onFetchSchools: (dzongkhag_id: string) =>
       dispatch(fetchSchools(dzongkhag_id)),
   onFetchEccd: (dzongkhag_id: string) => dispatch(fetchEccd(dzongkhag_id)),
});
export default connect(mapStateToProps, mapDispatchToProps)(FilterDCDDData);
